import { Card, CbhIcon, Text } from "@clipboard-health/ui-components";
import { CardContent, DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { FOOTER_BUTTON_MIN_WIDTH, TB_TEST_UPLOAD_CALLOUT } from "../constants";
import { type TbTestType } from "../types";
import { TbTestChecklist } from "./Checklist";

interface InstructionsStepProps {
  testType: TbTestType;
  onNext: () => void;
  onBack: () => void;
}

export function InstructionsStep(props: InstructionsStepProps) {
  const { testType, onNext, onBack } = props;

  return (
    <>
      <DialogContent>
        <Stack gap={8}>
          <Text variant="h3">Upload TB test result</Text>

          <Card outlined variant="quaternary">
            <CardContent>
              <Stack direction="row" gap={3} alignItems="flex-start">
                <CbhIcon type="lightbulb-gray" size="medium" />
                <Text variant="body2">{TB_TEST_UPLOAD_CALLOUT}</Text>
              </Stack>
            </CardContent>
          </Card>

          <Stack gap={3}>
            <Text variant="body1" sx={{ fontWeight: "bold" }}>
              TB test result must include
            </Text>

            <TbTestChecklist testType={testType} />
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          size="large"
          variant="contained"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onNext}
        >
          Upload
        </Button>
      </DialogFooter>
    </>
  );
}
